<template>
  <page-background>
    <template v-slot>
      <auth-card
        class="registerView"
        inverted="left"
      >
        <div class="registerView__right">
          <el-link @click="$router.push({ name: 'login' })">
            <i class="el-icon-back"></i>&nbsp;&nbsp;{{ $t('auth.register.view.loginButton') }}
          </el-link>
          <h1 class="appContent__title">{{ $t('pageNames.' + $route.name) }}</h1>
          <el-alert
            v-if="hasAlert"
            title="Réservation"
            description="Inscrivez vous pour commencer à compléter votre dossier."
            type="success"
          />
          <register-form />
        </div>
      </auth-card>
    </template>
  </page-background>
</template>

<script>
import AuthCard from '@/components/auth/AuthCard'
import RegisterForm from '@/components/auth/RegisterForm'
import { mapState } from 'vuex'

export default {
  name: "Register",
  components: {
    AuthCard,
    RegisterForm
  },
  computed: {
    ...mapState({
      availability: state => state.residences.selectedAvailability
    }),
    hasAlert() {
      if (this.$route.params.reservation && this.availability) {
        return true
      }

      return false
    }
  }
}
</script>

<style lang="scss" scoped>
$c: '.registerView';

#{$c} {
  @include respond-above(xs) {
    min-height: calc(100vh - 125px);
  }

  #{$c}__right {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
  }

  #{$c}__right {
    padding: 92px 36px 20px 36px;
    @include respond-above(xs) {
      padding: 72px 72px 20px 72px;
    }

    .el-alert {
      text-align: left;
    }
    .el-icon-back {
      color: $--color-primary;
    }
    h1 {
      padding-top: 30px;
      padding-bottom: 25px;
    }
  }
}
</style>